<script setup lang="ts" generic="T">
import { cn } from 'pejer/src/lib/utils'
import { usePejerBase } from '../stores/pejerData'
import { ApiUrls } from '../types/base'
import InvalidPermissionsTooltip from './InvalidPermissionsTooltip.vue'
import Button, { ButtonProps } from './ui/button/Button.vue'

const props = defineProps<
  {
    url?: ApiUrls<T>
    class?: string
  } & ButtonProps
>()

const pejer = usePejerBase()
const { url: _, ...attrs } = props
</script>
<template>
  <Button v-bind="attrs" v-if="!url || pejer.isPermitted(url as ApiUrls)">
    <slot />
  </Button>
  <InvalidPermissionsTooltip v-else :missing-permissions="url.permissions" isAction>
    <Button
      :class="cn('cursor-not-allowed relative disabled:pointer-events-auto', props.class)"
      v-bind="attrs"
      disabled
    >
      <slot />
      <div class="absolute bg-red-800 rounded-md w-1 h-1 top-[6px] right-1" />
    </Button>
  </InvalidPermissionsTooltip>
</template>
